// extracted by mini-css-extract-plugin
export var id_bg01 = "RecruitBg-module--id_bg01--2ORGQ";